import React, { useCallback, useEffect, useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import { notBlank } from "../../util/ext";
import { useAllModules } from "../../manage-subscriptions/subscriptionService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Skeleton } from "@material-ui/lab";

const DefaultModulesDialog = ({ open, onCancel, onApply }) => {
  const [selectedModule, setSelectedModule] = useState(null);
  const [modules, setModules] = useState([]);

  const allModules = useAllModules();
  useEffect(() => {
    if (allModules.isSuccess && notBlank(allModules.data)) {
      setModules(allModules.data);
    }
  }, [allModules.isSuccess, allModules.data]);

  const handleModuleChange = useCallback((_event, module) => {
    setSelectedModule(module);
  }, []);

  const handleApply = async () => {
    if (notBlank(selectedModule)) {
      onApply(selectedModule);
    } else {
      onCancel();
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">Add Default Module</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select a Module to add to the Default Modules list.
        </DialogContentText>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {notBlank(modules) ? (
              <Autocomplete
                id="modules"
                options={modules}
                getOptionLabel={option => option.displayName || option.name}
                value={selectedModule || null}
                onChange={handleModuleChange}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Modules"
                    placeholder="Select..."
                  />
                )}
              />
            ) : (
              <Skeleton variant="text" />
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultModulesDialog;
